export default "\n<button [disabled]=\"isDisabled\" matTooltip={{tooltip}} mat-raised-button ><span class=\"btn-txt\">{{name}}</span></button>\n\n"